import React from "react";
import GD_Project_1 from "./graphic_design/GD_Project_1";
import GD_Project_2 from "./graphic_design/GD_Project_2";
import GD_Project_3 from "./graphic_design/GD_Project_3";
import GD_Project_4 from "./graphic_design/GD_Project_4";
import GD_Project_5 from "./graphic_design/GD_Project_5";
import GD_Project_6 from "./graphic_design/GD_Project_6";

const GraphicDesign = () => {
  return (
    <>
      <div className="image-box-wrapper row justify-content-center">
        <GD_Project_1 />
        <GD_Project_2 />
        <GD_Project_3 />
        <GD_Project_4 />
        <GD_Project_5 />
        <GD_Project_6 />
        <div className="content"></div>
      </div>
      {/* <button className="btn-main-offer see-more-btn collapsible">
        See More
      </button> */}
    </>
  );
};

export default GraphicDesign;
